// Open external links in a proper system/Custom-Tab browser on native, instead
// of navigating the app's own WebView (which would strand the user with no way
// back). Also exposes window.openExternal(url) for programmatic links.

import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

const isNative = () => Capacitor.isNativePlatform?.() === true;

// The app is served from https://localhost (or capacitor://) inside the WebView.
const isExternal = (url) => {
  try {
    const u = new URL(url, window.location.href);
    if (u.protocol === 'mailto:' || u.protocol === 'tel:') return false; // handled by OS
    if (!/^https?:$/.test(u.protocol)) return false;
    return u.host !== window.location.host;
  } catch { return false; }
};

export const openExternal = async (url) => {
  if (!url) return;
  if (isNative()) {
    try { await Browser.open({ url }); return; }
    catch (e) { console.warn('Browser.open failed:', e); }
  }
  window.open(url, '_blank', 'noopener,noreferrer');
};

const initLinks = () => {
  if (!isNative()) return;

  // Delegated handler: intercept clicks on external anchors and open them in a
  // Custom Tab so they don't replace the app's WebView.
  document.addEventListener('click', (e) => {
    const a = e.target?.closest?.('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;
    // mailto/tel are left to the OS. Same-origin SPA links stay in-app.
    if (a.target === '_blank' || isExternal(href)) {
      if (isExternal(href)) {
        e.preventDefault();
        openExternal(href);
      }
    }
  }, true);
};

if (typeof window !== 'undefined') {
  window.openExternal = openExternal;
}

initLinks();
